import { h } from 'preact';
const RightArrow = (props) => (
  <svg viewBox="0 0 72 72" class={props.class}>
    <polygon points="15,62 41,36 15,10 23,2 57,36 23,70"/>
	</svg>
);
export default RightArrow;


// WEBPACK FOOTER //
// ../q-mdc/icons/right-arrow/index.js